export default {
  title: {
    candidateIndexPage: '求职者',
    indexPage: '招聘解决方案',
    intelligencePage: '菁客智能',
    login: '登录',
    register: '注册',
    forgetPassword: '忘记密码？',
    resetPassword: '重置密码',
    createPassword: '创建密码',
    '51job': '前程无忧',
    jobStreet: '求职工作街',
    emailDialog: '您之前活动中的以下邮箱与您的手机号码相关联。请选择一个邮箱并点击“使用此账户”以继续，或者点击“创建新账户”。',
    registerWithAjinga: '注册菁客',
    companyRegister: '公司注册'
  },
  label: {
    loginOtherAccount: '使用其他账号',
    otherAccount: {
      '51job': '前程无忧',
      facebook: 'Facebook',
      linkedin: 'LinkedIn',
      jobStreet: '求职工作街'
    },
    firstName: '名',
    lastName: '姓',
    email: '邮箱',
    phone: '手机号码',
    verifyCode: '验证码',
    chinesePhone: '大陆手机号',
    smsCode: '手机验证码',
    captcha: '图形验证码',
    resendVerifyCode: '重新发送（{countdown}）',
    employeeRegister: {
      registerCompany: '公司',
      name: '姓名',
      email: '邮箱',
      employeeGroupIdNum: '组编号',
      employeeIdNum: '员工工号',
      phone: '手机号码',
      password: '密码',
      authInfo: '有效信息',
      pinCode: '公司邀请码'
    },
    register: '注册/登录',
    passwordLogin: '密码登录',
    lastLoginTime: '（最后使用于：{time}）'
  },
  placeholder: {
    email: '请输入邮箱',
    emailOrPhone: '请输入邮箱/手机号',
    password: '请输入密码',
    createPassword: '请创建密码',
    employeeNumber: '请输入员工号',
    customEmployeeNumber: '请输入{customTip}',
    firstName: '请输入名',
    lastName: '请输入姓',
    phone: '请输入手机号码',
    verifyCode: '请输入验证码',
    pleaseEnter: '请输入{placeholder}',
    chinesePhone: '请输入大陆手机号',
    smsCode: '请输入手机验证码',
    captcha: '请输入图形验证码',
    confirmPassword: '请再次输入密码',
    employeeRegister: {
      registerCompany: '请选择公司',
      name: '请输入姓名',
      email: '请输入邮箱',
      employeeGroupIdNum: '请输入组编号',
      employeeIdNum: '请输入员工工号',
      phone: '请输入手机号码',
      password: '请输入密码',
      authInfo: '请输入有效信息',
      pinCode: '请输入公司邀请码'
    },
    companyName: '请输入公司名称'
  },
  btn: {
    login: '登录',
    forgetPassword: '忘记密码',
    register: {
      candidate: '现在加入',
      employee: '现在注册'
    },
    getVerifyCode: '获取验证码',
    resendVerifyCode: '重新发送',
    back: '返回',
    useEmailLogin: '使用此账户',
    continueRegister: '创建新账户'
  },
  message: {
    loginCompany: '登录',
    registerCompany: '注册一个新账号',
    phoneNotChange: '您的手机号未改变',
    updateSuccess: '更新成功',
    loginTip: {
      hasAccount: '已经有一个账号？',
      login: '去登录。',
      loginByVerifyCode: '验证码登录',
      loginByPassword: '密码登录'
    },
    registerTip: {
      noAccount: '还没有账号？',
      register: '注册新的账号。',
      registerByEmail: '使用邮箱注册'
    },
    hrLoginTip: '请使用你的公司邮箱进行登录',
    policy: {
      tip: '我同意',
      userAgreement: '菁客用户协议',
      privacyPolicy: '菁客隐私政策',
      loginTip: '未注册手机号将自动注册'
    },
    agreePolicyFirst: '请阅读并且同意协议',
    accountOrPasswordIsWrong: '用户名或密码错误',
    lockAccount: {
      lockAfter: '用户名或密码错误, 您还可以重试{times}次，超过账号将被锁定60分钟',
      countdownTime: '您的账号已被锁定，请于{countdownTime}分钟后再次尝试登录'
    },
    getVerifyCodeFirst: '请先获取验证码',
    invalidVerifyCode: '错误的验证码',
    passwordRule: '密码必须包含大小写字母和数字，长度至少10位，特殊符号只能是_#@.-',
    employeeRegisterTip: '完成注册后我们会向您的邮箱发送一封确认邮件，请注意查收并点击邮件中链接激活您的员工身份。请在24小时内点击邮件内的链接来激活你的账号。',
    resetTip: {
      label: ['通过', 'type_link_html', '找回密码。'],
      type: {
        email: '邮箱',
        phone: '手机号码'
      }
    },
    notSamePassword: '请确认密码相同',
    userIsNotExists: '账号不存在，请重新输入',
    candidateIsNotExists: '账号不存在，请重新输入',
    resetPasswordSuccess: '重置密码成功！',
    createPasswordSuccess: '创建密码成功。',
    passwordSameAsPrevious: '新密码不能和旧密码相同',
    sentResetPasswordEmail: 'service@mail.ajinga.com 会给您的邮箱发送一封重置密码的邮件。  请在接下来的 24 小时内点击电子邮件中的链接，重置您的密码。',
    bindEmailRequired: '请选择您的邮箱'
  },
  accountType: {
    AGENCY: '猎头',
    HR: '招聘人员',
    HIRING_MANAGER: '招聘经理',
    EMPLOYEE: '员工',
    CANDIDATE: '求职者',
    ALUMNI: '前员工'
  }
}
